import script from "./PasoCotizacionFinalizada.vue?vue&type=script&setup=true&lang=js"
export * from "./PasoCotizacionFinalizada.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__